import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
  {
    path: '/',
    name: 'OutdoorVision',
    component: Home,
    meta: { title: 'OutdoorVision /  Devenez l\'expert de votre territoire' },
  },
  {
    path: '/MapF1',
    name: 'Vue générale',
    component: () => import(/* webpackChunkName: "f1" */ '../views/MapF1.vue'),
    meta: { title: 'OutdoorVision / Vue générale' },
  },
  {
    path: '/MapF3',
    name: 'Emprise géographique',
    component: () => import(/* webpackChunkName: "f3" */ '../views/MapF3.vue'),
    meta: { title: 'OutdoorVision / Emprise géographique' },
  },
  {
    path: '/MapF4',
    name: 'Itinéraire défini',
    component: () => import(/* webpackChunkName: "f4" */ '../views/MapF4.vue'),
    meta: { title: 'OutdoorVision / Itinéraire défini' },
  },
  {
    path: '/MapF5',
    name: 'Départs/Arrivées',
    component: () => import(/* webpackChunkName: "f5" */ '../views/MapF5.vue'),
    meta: { title: 'OutdoorVision / Départs/Arrivées' },
  },
  {
    path: '/MapF6Diff',
    name: 'Comparaison temporelle (diff)',
    component: () => import(/* webpackChunkName: "f6" */ '../views/MapF6Diff.vue'),
    meta: { title: 'OutdoorVision / Comparaison temporelle' },
  },
  {
    path: '/MapF6Double',
    name: 'Comparaison temporelle (stereo)',
    component: () => import(/* webpackChunkName: "f6" */ '../views/MapF6Double.vue'),
    meta: { title: 'OutdoorVision / Comparaison temporelle' },
  },
  {
    path: '/MapF7',
    name: 'Répartition des activités',
    component: () => import(/* webpackChunkName: "f7" */ '../views/MapF7.vue'),
    meta: { title: 'OutdoorVision / Répartition des activités' },
  },
  {
    path: '/MapF8',
    name: 'Zones de pauses',
    component: () => import(/* webpackChunkName: "f8" */ '../views/MapF8.vue'),
    meta: { title: 'OutdoorVision / Zones de pauses' },
  },
  { path: '/:pathMatch(.*)*', name: '404', component: () => import('../views/404.vue') },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
